import { Stack } from "@mui/material";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";
import { ButtonLink } from "Components/Shared/ButtonLink";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { AuthButtons } from "Components/Auth/Shared/AuthButtons";
import { useSelector } from "react-redux";
import type { RootStateType } from "State/Store";

const ComponentResources = Resources.Transactions.Anonymous;

type Props = {
  affiliateCode?: string;
};

export const SignUpButtons = ({ affiliateCode }: Props) => {
  const { t } = useResource();
  const ssoIsLoading = useSelector((s: RootStateType) => s.auth.ssoIsLoading);

  const signUpLink = affiliateCode
    ? `${appUrl("sign-up")}?affiliateCode=${encodeURIComponent(affiliateCode)}`
    : appUrl("sign-up");

  return (
    <Stack gap={2} my={1}>
      <ButtonLink
        fullWidth
        color="primary"
        link={signUpLink}
        text={t(ComponentResources.CreateAccountViaEmail)}
        startIcon={<MailOutlineIcon />}
        variant="contained"
        sx={{ height: "46px", textTransform: "none", fontWeight: 400 }}
      />
      <AuthButtons isLoading={ssoIsLoading} affiliateCode={affiliateCode} />
    </Stack>
  );
};
